<template>
  <div
		:class="['slide-first-wrapper', {'dark-blue-mode' : $route.meta.headerColor === 'dark'}]"
		@mouseleave="openSideMenuOverflowElement($event)" id="slide-first"
	>
    <div class="side-menu-navigation">
			<span class="links-header">{{ $t('sideMenu.platform') }}</span>
			<span
				@click="tryRedirect('/gop/home', 'GOP_HOME')"
				class="link"
			>
				<span class="hover-container create-story-button gop-container">
					<img src="@/common/assets/icons/platform.svg" alt="platform">
					<span>GOP</span>
				</span>
			</span>

      <span class="links-header">{{ $t('sideMenu.stories') }}</span>

			<div
				@click="tryRedirect('/home', 'HOMEPAGE_DRC')"
				class="link"
				:class="checkIsActivePage('/home')"
			>
				<div class="hover-container">
					<img src="@/common/assets/icons/home.svg" alt="home">
					<span>{{$t('sideMenu.home') }}</span>
				</div>
			</div>

			<span
				@click="closeSideMenuWithRedirect"
				class="link"
				:class="checkIsActivePage('/submission/new-project-form')"
				@mouseenter="openSideMenuOverflowElement($event)"
			>
				<span class="hover-container create-story-button">
					<img class="plus" src="@/common/assets/icons/plus.svg" alt="plus">
					<span>{{ $t('sideMenu.create') }}</span>
				</span>
			</span>

      <div
          @click="tryRedirect(getBaseUrl(), 'ALL_STORIES')"
          class="link"
          :class="checkIsActivePage('/projects/search')"
      >
        <div class="hover-container">
          <img src="@/common/assets/icons/search.svg" alt="search">
          <span>{{ $t('sideMenu.allStories') }}</span>
        </div>
      </div>

      <router-link
          @click.native="closeSideMenu"
          class="link"
          tag="span"
          :class="checkIsActivePage('/manage/content')"
          to="/manage/content"
          @mouseenter.native="openSideMenuOverflowElement($event)"
          v-if="hasPermission(PERMISSIONS.additionalCmtAccess)">
        <div class="hover-container">
          <img src="@/common/assets/icons/manage.svg" alt="manage">
          <span>{{ $t('sideMenu.manage') }}</span>
        </div>
      </router-link>

			<div
				@click="tryRedirect('/control-panel/landing-page', 'CONTROL_PANEL')"
				class="link"
				:class="checkIsActivePage('/control-panel')"
				@mouseenter="openSideMenuOverflowElement($event)"
				v-if="hasPermission(PERMISSIONS.additionalCmtAccess)"
			>
				<div class="hover-container">
					<img src="@/common/assets/icons/administration.svg" alt="control-panel">
					<span>{{ $t('sideMenu.controlPanel') }}</span>
				</div>
			</div>

      <span class="links-header">{{ $t('sideMenu.personal') }}</span>

      <div
          @click="tryRedirect('/my-stories', 'MY_STORIES')"
          class="link"
          :class="checkIsActivePage('/my-stories')"
      >
        <div class="hover-container">
          <img src="@/common/assets/icons/file.svg" alt="file">
          <span>{{ $t('sideMenu.myStories') }}</span>
        </div>
      </div>

			<div
				@click="tryRedirect('/my-subscriptions', 'MY_SUBSCRIPTIONS')"
				class="link"
				:class="checkIsActivePage('/my-subscriptions')"
			>
				<div class="hover-container">
					<img src="@/common/assets/icons/subscriptions.svg" alt="file">
					<span>{{ $t('sideMenu.mySubscriptions') }}</span>
				</div>
			</div>

      <span class="links-header">{{ $t('sideMenu.pages') }}</span>

      <router-link
          @click.native="closeMenu('RESOURCES')"
          tag="span" class="link"
          :class="checkIsActivePage('/resources')"
          @mouseenter.native="openSideMenuOverflowElement($event)"
          to="/resources">
        <div class="hover-container">
          <img src="@/common/assets/icons/question.svg" alt="question">
          <span>{{ $t('sideMenu.FAQs') }}</span>
        </div>
      </router-link>

      <ApplicationLanguageControl :containerClasses="['mt-30', 'mobile']" v-if="showLanguageOptions && $route.meta.headerColor !== 'dark'"/>

    </div>

  </div>
</template>

<script>
import {EventSideMenu} from "@/common/configurations/event-bus.js";
import ApplicationLanguageControl from "@/common/components/ApplicationLanguageControl.vue";
import userMixin from '@/drc/mixins/userMixin';
import slideMenuMixin from "@/common/mixins/slide-menu-mixin";
import {searchFilterMixin} from "@/drc/mixins/search-filter-mixin";
import {PERMISSIONS} from "@/common/utils/constants";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

export default {
  name: "SlideFirst",
  mixins: [userMixin, slideMenuMixin, searchFilterMixin],
  components: {
    ApplicationLanguageControl,
  },
  data() {
    return {
      mobileMod: false,
			PERMISSIONS: PERMISSIONS
    }
  },
  mounted() {
    this.fetchIndustries();
    this.fetchTechPractices();
    this.fetchServiceLines();
  },
  methods: {
		closeMenu(type) {
			const props = {
				action: `LEFTSIDE_MENU_${type.toUpperCase()}`,
				comment: JSON.stringify({current_route: `${this.$route.path}`, type: "BUTTON_CLICK"})
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
			this.closeSideMenu();
		},
    tryRedirect(page, type) {
			if(page === '/gop/home') {
				this.addBurgerMenuStatistic(page, type);
				this.$router.push(page);
			}	else if (this.$route.path.indexOf(page) !== -1 || page.indexOf(this.$route.path) !== -1) {
        this.closeSideMenu();
      } else {
				this.addBurgerMenuStatistic(page, type);
				this.$router.push(page);
      }
    },
		addBurgerMenuStatistic(page, type) {
			const now = new Date();
			this.$gtag.event("drc_redirect", {
				event_type: "click",
				event_category: "drc",
				event_page: "everywhere",
				event_label: "Going to page in left menu",
				event_location: this.$route.name,
				event_path: this.$route.path,
				user_id: this.$store.getters.getUser.id,
				user_name: this.$store.getters.getUser.fullName,
				user_email: this.$store.getters.getUser.email,
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
				time: new Date().toJSON().split('T')[1].split('.')[0],
				page: page,
				type: type
			});
			const props = {
				action: `LEFTSIDE_MENU_${type.toUpperCase()}`,
				comment: JSON.stringify({current_route: `${this.$route.path}`, toPage: `${page}`, type: "BUTTON_CLICK"})
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
		},
    openSideMenuOverflowElement(event) {
      if (event && event.target && event.target.classList.contains("link")) {

        this.closeAllOpenedHovers();
        if (window.innerWidth > this.tabletDisplayPx) {
          const maxHeight = 900;
          this.adjustScrollArea(event, maxHeight)
          event.target.lastChild.firstChild.classList.add('active')
          event.target.lastChild.classList.add('active')
        }
      }

    },
    adjustScrollArea(event, maxHeight) {
      if (window.innerHeight >= maxHeight) {
        event.target.lastChild.firstChild.style.overflowY = "unset"
        event.target.lastChild.firstChild.style.overflowX = "unset"
        event.target.lastChild.firstChild.style.maxHeight = "unset"
      }
    },
    closeSideMenuWithRedirect() {
      if (window.innerWidth < 768) {
        EventSideMenu.$emit("toggle-sidemenu");
        EventSideMenu.$emit("toggle-burger-logo");
        this.$parent.$parent.$parent.$refs.mainContent.style.overflow = "auto";
      }
      this.redirectToNewSubmissionForm();
			const props = {
				action: "LEFTSIDE_MENU_CREATE",
				comment: JSON.stringify({current_route: `${this.$route.path}`, type: "BUTTON_CLICK"})
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
    },
    redirectToNewSubmissionForm() {
      if (this.$route.name === 'submission-new-project-form') {
        location.reload();
      } else {
        this.redirectToSubmissionForm();
      }
    }
  },
  created() {
    if (window.innerWidth <= 768) {
      this.mobileMod = true;
    }
  }
}
</script>

<style lang="sass">
@import "@/common/assets/css/_variables.scss"

.slide-first-wrapper
	width: 100%
	display: flex
	flex-direction: column
	justify-content: space-between
	height: 100%
	position: absolute
	left: 0

	.side-menu-navigation
		padding: 15px 30px
		display: flex
		flex-direction: column
		gap: 15px

	@media (max-width: 425px)
		padding: 15px

	.links-header
		font-family: 'Roboto', sans-serif
		font-style: normal
		font-weight: 500
		font-size: 12px
		line-height: 14px
		letter-spacing: 0.05em
		text-transform: uppercase
		color: #C4C4C4

		&.first-child
			margin-top: 0

	.link
		cursor: pointer
		width: 100%
		position: relative

		.hover-container
			padding: 7px 10px
			border-radius: 5px
			display: flex
			flex-direction: row

			span
				font-family: 'Roboto', serif
				font-style: normal
				font-weight: 400
				font-size: 16px
				letter-spacing: 0.05em
				color: #0e2b40
				vertical-align: middle
				padding-top: 1px

			img
				max-width: 22px
				width: 22px
				height: 22px
				margin-right: 15px
				vertical-align: bottom
				filter: brightness(0) saturate(100%) invert(14%) sepia(63%) saturate(555%) hue-rotate(161deg) brightness(94%) contrast(98%)

			path
				fill: red

			.not-filled
				filter: brightness(0) saturate(100%) invert(10%) sepia(95%) saturate(1172%) hue-rotate(174deg) brightness(100%) contrast(101%)
				stroke: black
				stroke-width: 1px

			.filled
				filter: brightness(0) saturate(100%) invert(10%) sepia(95%) saturate(1172%) hue-rotate(174deg) brightness(100%) contrast(101%)

		&:hover
			.hover-container
				background-color: #FEF1D6

		&.active
			.hover-container
				background-color: #FFB81C

	.profile-info
		padding: 10px
		display: flex
		gap: 10px

		.avatar
			width: 35px
			height: 35px
			color: #FFB81C
			font-family: 'Roboto', serif
			font-style: normal
			font-weight: 700
			font-size: 10px
			border-radius: 50%
			background: #002A41
			display: flex
			justify-content: center
			align-items: center
			text-transform: uppercase

		.profile
			flex-basis: 70%
			display: flex
			flex-direction: column

			.name
				font-family: 'Roboto', serif
				font-style: normal
				font-weight: 700
				font-size: 12px
				color: #011723

			.email
				font-family: 'Roboto', serif
				font-style: normal
				font-weight: 400
				font-size: 12px
				color: #011723
				word-break: break-all

		.logout
			text-align: center
			margin:  auto
			cursor: pointer
			padding: 5px
			border-radius: 5px
			position: relative

			img
				vertical-align: middle

			&:hover
				background-color: #FEF1D6

			.logout-tooltip-container
				display: none

				@media (min-width: $tablet)
					position: fixed
					bottom: 15px
					left: 292px
					width: fit-content
					background: white
					border-radius: 5px
					height: inherit
					box-shadow: -5px -1px 22px -5px rgba(0, 0, 0, 0.24)

					p
						margin: 0
						padding: 0 10px
						color: #0e2b40
						font-family: "Roboto", sans-serif
						font-weight: 400
						font-size: 1.6vh
						width: inherit
						white-space: nowrap

			.logout-tooltip-container::before
				@media (min-width: $tablet)
					content: ''
					height: 0
					width: 0
					position: absolute
					border-style: solid
					border-width: 8px 9.7px 8px 0
					border-color: transparent white transparent transparent
					top: 41.5%
					right: 100%
					margin-top: -5px

			.show-tooltip
				@media (min-width: $tablet)
					display: block

		&.dark-blue-mode
			.avatar
				background: #8E8E93

			.profile
				.name, .email
					color: white


.dark-blue-mode
	.links-header
		color: #8E8E93

	.side-menu-navigation
		.link
			.hover-container
				span
					color: #FCFCFE

				img
					filter: brightness(0) saturate(100%) invert(90%) sepia(15%) saturate(39%) hue-rotate(207deg) brightness(104%) contrast(102%)

					&.plus
						width: 19px
						height: 19px

			&:hover
				.hover-container
					span
						color: #0e2b40

					img
						filter: brightness(0) saturate(100%) invert(12%) sepia(10%) saturate(5436%) hue-rotate(168deg) brightness(96%) contrast(93%)
</style>
